import { AccountType, PwcCustomerType } from 'types/account';

import { CreatedAccount } from './types';

export const isCreateAccountFormComplete = (
  formValues: CreatedAccount,
  accountType: AccountType,
  pwcCustomerType: PwcCustomerType,
): boolean => {
  const trim = (v: unknown) => (v ?? '').toString().trim();

  if (!trim(formValues.username) || !trim(formValues.firstName) || !trim(formValues.lastName) || !trim(formValues.accountName)) {
    return false;
  }

  if (accountType === AccountType.Pwc) {
    if (!trim(formValues.mainFiatCurrency)) {
      return false;
    }
    if (pwcCustomerType === PwcCustomerType.Business && !trim(formValues.groupAccountId)) {
      return false;
    }
    return true;
  }

  if (accountType === AccountType.Pwc_Group) {
    return Boolean(trim(formValues.parentAccountUuid));
  }

  return false;
};
